module.exports = __webpack_public_path__ + "img/Logotipo.03fc00d0.png";